module.exports = __webpack_public_path__ + "static/media/biteme.c97bd259.jpg";